import axios from 'axios';
import {
  ONLINE_STORE_CHANNEL,
  SHOULD_MOCK,
  UI_FLAGS,
} from 'utils/onlineStoreUtils';
import {
  outletById,
  shopById,
  GET_SHOP,
  CREATE_SHOP,
  GET_BUSINESS_INFO,
  PATCH_META_TAG,
} from './constants';

const fbShops = [
  {
    id: 100,
    outlet_id: 101,
    status: 'ACTIVE',
    channel: 'FACEBOOK',
    additional: {
      facebook_username: 'facebook_username',
      instagram_username: 'instagram_username',
      facebook_page_name: 'facebook_page_name',
      facebook_page_link: 'https://mokapos.com',
    },
    item_stats: {
      total_items: 122,
      total_live_items: 102,
      total_failed_items: 20,
    },
    ui_flags: {},
    item_sync_status: 'IN_PROGRESS',
    item_start_sync_at: '2019-10-03T14:39:26.936000+07:00',
    item_last_synced_at: '2019-10-03T14:39:26.936000+07:00',
  },
  {
    id: 101,
    outlet_id: 102,
    status: 'ACTIVE',
    channel: 'FACEBOOK',
    additional: {
      facebook_username: 'facebook_username',
      instagram_username: 'instagram_username',
      facebook_page_name: 'facebook_page_name',
      facebook_page_link: 'https://mokapos.com',
    },
    item_stats: {
      total_items: 0,
      total_live_items: 0,
      total_failed_items: 0,
    },
    ui_flags: {},
    item_sync_status: null,
    item_start_sync_at: null,
    item_last_synced_at: null,
  },
  {
    id: 103,
    outlet_id: 103,
    status: 'PENDING',
    channel: 'FACEBOOK',
    additional: {
      facebook_username: 'facebook_username',
      instagram_username: 'instagram_username',
      facebook_page_name: 'facebook_page_name',
      facebook_page_link: 'https://mokapos.com',
    },
    item_stats: {
      total_items: 0,
      total_live_items: 0,
      total_failed_items: 0,
    },
    ui_flags: {},
    item_sync_status: null,
    item_start_sync_at: null,
    item_last_synced_at: null,
  },
  {
    id: 104,
    outlet_id: 105,
    status: 'ACTIVE',
    channel: 'FACEBOOK',
    additional: {
      facebook_username: 'facebook_username',
      instagram_username: 'instagram_username',
      facebook_page_name: 'facebook_page_name',
      facebook_page_link: 'https://mokapos.com',
    },
    item_stats: {
      total_items: 0,
      total_live_items: 0,
      total_failed_items: 0,
    },
    ui_flags: {},
    item_sync_status: null,
    item_start_sync_at: null,
    item_last_synced_at: null,
  },
  {
    id: 105,
    outlet_id: 106,
    status: 'ACTIVE',
    channel: 'FACEBOOK',
    additional: {
      facebook_username: 'facebook_username',
      instagram_username: 'instagram_username',
      facebook_page_name: 'facebook_page_name',
      facebook_page_link: 'https://mokapos.com',
    },
    item_stats: {
      total_items: 122,
      total_live_items: 102,
      total_failed_items: 20,
    },
    ui_flags: {
      [UI_FLAGS.PRODUCT_SYNCS_COMPLETED_SHOWN]: true,
    },
    item_sync_status: 'DONE',
    item_start_sync_at: '2019-10-03T14:39:26.936000+07:00',
    item_last_synced_at: '2019-10-03T14:39:26.936000+07:00',
  },
];

const googleShops = [
  {
    id: 200,
    outlet_id: 101,
    status: 'ACTIVE',
    channel: 'GOOGLE',
    additional: {
      google_shopping_id: '123456789',
      google_email: 'dummy_email@gmail.com',
    },
    item_stats: {
      total_items: 122,
      total_live_items: 102,
      total_failed_items: 20,
    },
    ui_flags: {},
    item_sync_status: 'IN_PROGRESS',
    item_start_sync_at: '2019-10-03T14:39:26.936000+07:00',
    item_last_synced_at: '2019-10-03T14:39:26.936000+07:00',
  },
  {
    id: 201,
    outlet_id: 102,
    status: 'ACTIVE',
    channel: 'GOOGLE',
    additional: {
      google_shopping_id: '123456789',
    },
    item_stats: {
      total_items: 0,
      total_live_items: 0,
      total_failed_items: 0,
    },
    ui_flags: {},
    item_sync_status: null,
    item_start_sync_at: null,
    item_last_synced_at: null,
  },
  {
    id: 204,
    outlet_id: 105,
    status: 'ACTIVE',
    channel: 'GOOGLE',
    additional: {
      google_shopping_id: '123456789',
      google_email: 'dummy_email@gmail.com',
    },
    item_stats: {
      total_items: 0,
      total_live_items: 0,
      total_failed_items: 0,
    },
    ui_flags: {},
    item_sync_status: null,
    item_start_sync_at: null,
    item_last_synced_at: null,
  },
  {
    id: 205,
    outlet_id: 106,
    status: 'ACTIVE',
    channel: 'GOOGLE',
    additional: {
      google_shopping_id: '123456789',
      google_email: 'dummy_email@gmail.com',
    },
    item_stats: {
      total_items: 122,
      total_live_items: 102,
      total_failed_items: 20,
    },
    ui_flags: {},
    item_sync_status: 'DONE',
    item_start_sync_at: '2019-10-03T14:39:26.936000+07:00',
    item_last_synced_at: '2019-10-03T14:39:26.936000+07:00',
  },
];

const businessInfo = {
  go_store_brand_page_url: 'https://testdomain.gostore.com',
  additional: {
    is_facebook_website_verified: false,
  },
};

function reject(error) {
  if (!error.response) {
    return Promise.reject(error);
  }

  const { data } = error.response;

  if (Array.isArray(data.errors) && data.errors.length > 0) {
    const errorDetail = data.errors[0];
    return Promise.reject(
      new Error(errorDetail.user_message || errorDetail.message)
    );
  }

  if (data.errors) {
    return Promise.reject(new Error(data.errors));
  }

  if (data.message) {
    return Promise.reject(new Error(data.message));
  }

  return Promise.reject(error);
}

export function getShopById({ shopId, itemStats }) {
  if (SHOULD_MOCK) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          status: 200,
          data: fbShops.concat(googleShops).filter(d => d.id === shopId)[0],
        });
      }, 1000);
    });
  }

  return axios
    .get(shopById(shopId), {
      params: {
        itemStats,
      },
    })
    .catch(reject);
}

export function getShops(channel, itemStats = false) {
  if (SHOULD_MOCK) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          status: 200,
          data: {
            shops:
              channel === ONLINE_STORE_CHANNEL.FACEBOOK ? fbShops : googleShops,
          },
        });
      }, 2000);
    });
  }

  return axios
    .get(GET_SHOP, {
      params: {
        channel,
        itemStats,
      },
    })
    .catch(reject);
}

export function createShop(channel, outletId) {
  if (SHOULD_MOCK) {
    return Promise.resolve({
      status: 200,
      data: { id: -2 },
    });
  }

  return axios
    .post(CREATE_SHOP, {
      channel,
      outlet_id: outletId,
    })
    .catch(reject);
}

export function deleteShop(shopId) {
  if (SHOULD_MOCK) {
    return Promise.resolve({
      status: 200,
      data: {},
    });
  }

  return axios.delete(shopById(shopId)).catch(reject);
}

export function syncProducts({ shopId }) {
  if (SHOULD_MOCK) {
    return Promise.resolve({
      status: 200,
      data: {},
    });
  }

  return axios.post(`${shopById(shopId)}/items/syncs`).catch(reject);
}

export function initiateProductExport({ shopId }) {
  if (SHOULD_MOCK) {
    return Promise.resolve({
      status: 200,
      data: {
        export_id: 1,
      },
    });
  }

  return axios.post(`${shopById(shopId)}/items/exports`).catch(reject);
}

export function getProductExportFileUrl({ shopId, exportId }) {
  if (SHOULD_MOCK) {
    return Promise.resolve({
      status: 200,
      data: {
        status: 'DONE',
        url:
          'https://mokapos-development.s3.amazonaws.com/uploads/export/2020/September/28/report-shifts-12-08-2020-c5f0.csv',
      },
    });
  }

  return axios
    .get(`${shopById(shopId)}/items/exports/${exportId}`)
    .catch(reject);
}

export function getProducts({ shopId, page, status, itemSyncStatus }) {
  if (SHOULD_MOCK) {
    const nextPage = page || 1;

    const items = [];
    for (let i = 0; i < 50; i++) {
      const rand = Math.floor(Math.random() * 2) + 1;
      const variants = [];

      for (let j = 0; j < rand; j++) {
        variants.push({
          item_variant_id: 123,
          variant_name: `Red / Large ${j}`,
          status:
            status !== 'ALL'
              ? status
              : Math.floor(Math.random() * 2) === 1
              ? 'LIVE'
              : 'FAILED',
          error_type: 'MISSING_ATTRIBUTES',
          error_details: {
            fields: ['Description', 'Product Attribute', 'Media'],
          },
        });
      }

      items.push({
        name: `Basic Shirt ${nextPage}${i}`,
        image_url:
          'https://lh3.googleusercontent.com/O2MuxaLgYLI87vRSaSM1bs5IVvYz9lDyrTwD6uPbqK2GnQnL5sFm4ZcAdFfDdeUG3Tw',
        variants,
      });
    }

    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          status: 200,
          data: {
            items,
            completed: nextPage > 3,
          },
        });
      }, 1000);
    });
  }

  return axios
    .get(`${shopById(shopId)}/items`, {
      params: { page: page || 1, status, itemSyncStatus },
    })
    .catch(reject);
}

export function registerMerchantAccount(shopId, email) {
  if (SHOULD_MOCK) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          status: 200,
          data: {},
        });
      }, 1000);
    });
  }

  return axios
    .post(`${shopById(shopId)}/merchant-accounts`, { email })
    .catch(reject);
}

export function updateShopUiFlags(shopId, payload) {
  if (SHOULD_MOCK) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          status: 200,
          data: {},
        });
      }, 1000);
    });
  }

  return axios.patch(`${shopById(shopId)}/ui-flags`, payload).catch(reject);
}

export function getBusinessInfo() {
  if (SHOULD_MOCK) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          status: 200,
          data: businessInfo,
        });
      }, 200);
    });
  }

  return axios.get(GET_BUSINESS_INFO).catch(reject);
}

export function patchMetaTag(name, content) {
  if (SHOULD_MOCK) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          status: 200,
          data: {},
        });
      }, 100);
    });
  }

  return axios.patch(PATCH_META_TAG, { name, content }).catch(reject);
}

export function getOutlet(outletId) {
  return axios.get(outletById(outletId)).catch(reject);
}
